import { useTheme } from '@mui/material';
import { Typography } from '../../Typography/Typography';
import { Timesheet } from '../../../types';
import { getMonthLabelShort } from '../../../utils/formatters';
import { useMemo } from 'react';

type Props = {
  updatedBy: Timesheet['updatedBy'];
  updated_at: Timesheet['updated_at'];
  /** Owner of the timesheet. When set and the editor differs, we surface "by <editor>". */
  ownerId?: number;
};
export function LastEditedCell({ updatedBy, updated_at, ownerId }: Props) {
  const { colors } = useTheme();

  // Surface "by <editor>" only when someone OTHER than the owner last edited (e.g. a Proxy acting on
  // behalf). Keyed on ownership, not on the editor holding the Proxy role — otherwise a Proxy +
  // Submitter editing their OWN timesheet would wrongly show "by <their own name>".
  const editedByOther = !!updatedBy?.id && ownerId != null && updatedBy.id !== ownerId;

  const formatedUpdatedAt = useMemo(() => {
    if (updated_at) {
      const date = updated_at?.split('T')[0].split('-').reverse();
      return `${date[0]} ${getMonthLabelShort(Number(date[1]))} ${date[2]}`;
    }
    return '';
  }, [updated_at]);

  return (
    <Typography variant='body' color={colors.text.main}>
      {formatedUpdatedAt}

      {editedByOther ? ` by ${updatedBy?.name}` : null}
    </Typography>
  );
}
